module.exports = "/_next/static/images/step_2-87be7570a78b59cee3d0bac9cafe1cf1.png";